// Path: src\Components\Common\TabPanelSolid.jsx
import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import Packs from "../Rewards/Packs";
// import RewardStore from "../../../src/Components/Rewards/RewardStore/RewardStoreList"
import MyRewardStore from "../../../src/Components/Rewards/RewardStore/MyRewards"
import Bundle from "../Rewards/Bundle";
import Avatars from "../Rewards/Avatars";
import RewardStore from "../Rewards/RewardStore/RewardStoreList";

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box className="tab-content">{children}</Box>}
    </div>
  );
};
const TabPanelSolid = ({ tabs, value, setValue, activeTab,getTabs }) => {
  const handleChange = (e, newValue) => {
    console.log(newValue);
    setValue(newValue); // Update the selected tab when changed
  };
  return (
    <>
      <div className="commontabs commontabs-four mt-3">
        <div className="commontabs-innerwrap tabs-width">
          <Tabs value={value} onChange={handleChange} className="tabs-container">
            {tabs?.map((tab, index) => (
              <Tab
                label={tab}
                value={index}
                className="tab"
                style={{ textTransform: "lowercase" }}
              //   onClick={()=>handleChange(index)}
              />
            ))}

          </Tabs>
        </div>
      </div>
      {console.log(value)}
        {tabs?.map((tab, index) => (
          getTabs(value,index,activeTab)  
      ))}
    </>
  );
};

export default TabPanelSolid;
